"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("./api");
var _enum = require("../enum");
var _projectManageApi = require("@/api/projectManageApi");
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
var _customerOrderPreApi = require("@/api/customerOrderPreApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var validatePhone = function validatePhone(rule, value, callback) {
  if (!value || /^\d{1,11}$/.test(value)) {
    callback();
    return;
  }
  callback(new Error('手机号仅支持数字，且最多输入11位'));
};
var _default = exports.default = {
  data: function data() {
    return {
      //弹窗
      integralFormEnum: _enum.integralFormEnum,
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15,
        customerId: '',
        sendType: '',
        fudouCardId: '',
        customerEmpType: '',
        projectNumber: '',
        phone: '',
        applicationNumber: '',
        auditStatus: '',
        startExeTime: '',
        endExeTime: '',
        startAuditTime: '',
        endAuditTime: '',
        creatorId: '',
        auditorId: '',
        companyId: '',
        appId: '',
        time: []
      },
      pageFromRules: {
        phone: [{
          validator: validatePhone,
          trigger: ['blur', 'change']
        }]
      },
      exeTimeRange: [],
      auditTimeRange: [],
      creatorOptions: [],
      auditorOptions: [],
      adminUserOptions: [],
      creatorLoading: false,
      loading: false,
      // 表格loading
      customers: [],
      sendTypeList: [],
      // 发卡类型列表
      fuCardOptions: [],
      // 福卡列表
      companyList: [],
      // 公司列表
      miniappList: [],
      // 小程序列表

      miniProgramCustomer: false,
      //是否为小程序客户
      miniProgramCustomerId: 0,
      //小程序客户id
      isMinAdmin: false,
      //是否为管理员
      totalIntegral: 0,
      totalRemainingIntegral: 0,
      summaryLoading: false,
      // 导出任务相关
      isExporting: false,
      // 是否正在导出
      exportProgress: 0,
      // 导出进度
      exportProgressText: '正在导出...',
      // 导出进度提示文本
      exportDialogTitle: '导出数据',
      // 导出弹窗标题
      exportConditionText: '',
      // 导出条件描述文本
      isExportingDetail: false,
      // 是否正在导出明细
      exportProgressDetail: 0,
      // 明细导出进度
      exportProgressTextDetail: '正在导出...',
      // 明细导出进度提示文本
      customColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      // 导出任务列表弹窗
      exportTaskDialogVisible: false,
      exportTaskList: [],
      exportTaskListTotal: 0,
      exportTaskLoading: false,
      exportTaskPageFrom: {
        page: 1,
        limit: 10
      }
    };
  },
  methods: {
    // 生成导出条件描述文本
    generateExportConditionText: function generateExportConditionText() {
      var exportType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '操作记录导出';
      var conditions = [];
      var p = this.pageFrom;
      conditions.push("\u3010".concat(exportType, "\u3011"));

      // 归属客户
      if (p.customerId) {
        var customerObj = this.customers.find(function (item) {
          return item.id === p.customerId;
        });
        conditions.push("\u5F52\u5C5E\u5BA2\u6237\uFF1A".concat(customerObj ? customerObj.name : '已选择'));
      } else {
        conditions.push('归属客户：全部');
      }

      // 发卡类型
      if (p.sendType) {
        var sendTypeObj = this.sendTypeList.find(function (item) {
          return item.id === p.sendType;
        });
        conditions.push("\u53D1\u5361\u7C7B\u578B\uFF1A".concat(sendTypeObj ? sendTypeObj.name : '已选择'));
      } else {
        conditions.push('发卡类型：全部');
      }

      // 发放福卡
      if (p.fudouCardId) {
        var fuCardObj = this.fuCardOptions.find(function (item) {
          return String(item.id) === String(p.fudouCardId);
        });
        conditions.push("\u53D1\u653E\u798F\u5361\uFF1A".concat(fuCardObj ? fuCardObj.cardName : p.fudouCardId));
      } else {
        conditions.push('发放福卡：全部');
      }

      // 发放方式
      if (p.customerEmpType !== '' && p.customerEmpType !== undefined) {
        var empTypeObj = this.integralFormEnum.find(function (item) {
          return item.value === p.customerEmpType;
        });
        conditions.push("\u53D1\u653E\u65B9\u5F0F\uFF1A".concat(empTypeObj ? empTypeObj.label : '已选择'));
      } else {
        conditions.push('发放方式：全部');
      }

      // 项目编号
      if (p.projectNumber) {
        conditions.push("\u9879\u76EE\u7F16\u53F7\uFF1A".concat(p.projectNumber));
      }

      // 申请编号
      if (p.applicationNumber) {
        conditions.push("\u7533\u8BF7\u7F16\u53F7\uFF1A".concat(p.applicationNumber));
      }

      // 审核状态
      if (p.auditStatus !== '' && p.auditStatus !== undefined && p.auditStatus !== null) {
        var auditStatusMap = {
          0: '待审核',
          1: '通过',
          2: '驳回',
          3: '无需审核'
        };
        conditions.push("\u5BA1\u6838\u72B6\u6001\uFF1A".concat(auditStatusMap[p.auditStatus] || '未知'));
      } else {
        conditions.push('审核状态：全部');
      }

      // 发放时间
      if (p.startExeTime && p.endExeTime) {
        conditions.push("\u53D1\u653E\u65F6\u95F4\uFF1A".concat(p.startExeTime, " \u81F3 ").concat(p.endExeTime));
      } else {
        conditions.push('发放时间：全部');
      }

      // 审核时间
      if (p.startAuditTime && p.endAuditTime) {
        conditions.push("\u5BA1\u6838\u65F6\u95F4\uFF1A".concat(p.startAuditTime, " \u81F3 ").concat(p.endAuditTime));
      } else {
        conditions.push('审核时间：全部');
      }

      // 提交人
      if (p.creatorId) {
        var creatorObj = this.creatorOptions.find(function (item) {
          return String(item.id) === String(p.creatorId);
        });
        conditions.push("\u63D0\u4EA4\u4EBA\uFF1A".concat(creatorObj ? creatorObj.realName : p.creatorId));
      } else {
        conditions.push('提交人：全部');
      }

      // 审核人
      if (p.auditorId) {
        var auditorObj = this.auditorOptions.find(function (item) {
          return String(item.id) === String(p.auditorId);
        });
        conditions.push("\u5BA1\u6838\u4EBA\uFF1A".concat(auditorObj ? auditorObj.realName : p.auditorId));
      } else {
        conditions.push('审核人：全部');
      }

      // 公司
      if (p.companyId) {
        var companyObj = this.companyList.find(function (item) {
          return item.id === p.companyId;
        });
        conditions.push("\u516C\u53F8\uFF1A".concat(companyObj ? companyObj.name : '已选择'));
      } else {
        conditions.push('公司：全部');
      }

      // 发卡小程序
      if (p.appId) {
        var appObj = this.miniappList.find(function (item) {
          return item.id === p.appId;
        });
        conditions.push("\u53D1\u5361\u5C0F\u7A0B\u5E8F\uFF1A".concat(appObj ? appObj.appName : '已选择'));
      } else {
        conditions.push('发卡小程序：全部');
      }

      // 时间
      if (p.time && p.time.length === 2) {
        conditions.push("\u65F6\u95F4\uFF1A".concat(p.time[0], " \u81F3 ").concat(p.time[1]));
      } else {
        conditions.push('时间：全部');
      }
      return conditions.join(' | ');
    },
    // 处理导出弹窗关闭
    handleExportDialogClose: function handleExportDialogClose(done) {
      if (this.exportProgress < 100) {
        this.$confirm('关闭后可在「导出任务」中查看进度和下载文件，是否关闭？', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '继续等待',
          type: 'warning'
        }).then(function () {
          done();
        }).catch(function () {});
      } else {
        done();
      }
    },
    // async getSummary() {
    //   try {
    //     this.summaryLoading = true;
    //     const params = { ...this.pageFrom };
    //     delete params.page;
    //     delete params.limit;
    //     if (params.time && params.time.length === 2) {
    //       params.startTime = params.time[0];
    //       params.endTime = params.time[1];
    //     }
    //     delete params.time;
    //
    //     const res = await getSummaryApi(params);
    //     if (res) {
    //       this.totalIntegral = res.totalIntegral || 0;
    //       this.totalRemainingIntegral = res.totalRemainingIntegral || 0;
    //     }
    //   } catch (error) {
    //     console.error('获取统计数据失败', error);
    //   } finally {
    //     this.summaryLoading = false;
    //   }
    // },
    customerEmpType: function customerEmpType(row) {
      switch (row.customerEmpType) {
        case 1:
          return '全员发放';
        case 2:
          return '全员回收';
        case 3:
          return '指定发放';
        case 4:
          return '指定回收';
        default:
          return '其他';
      }
    },
    status: function status(row) {
      switch (row.status) {
        case 1:
          return '已发放';
        case 2:
          return '已回收';
        case 3:
          return '待发放';
        case 4:
          return '已撤回';
        default:
          return '其他';
      }
    },
    getGrantStatusTextClass: function getGrantStatusTextClass(status) {
      var statusClassMap = {
        1: 'record-status-text--success',
        3: 'record-status-text--primary'
      };
      return statusClassMap[status] || 'record-status-text--info';
    },
    formatAuditStatus: function formatAuditStatus(row) {
      var auditStatusMap = {
        0: '待审核',
        1: '通过',
        2: '驳回',
        3: '无需审核'
      };
      return auditStatusMap[row.auditStatus] || '--';
    },
    getAuditStatusTextClass: function getAuditStatusTextClass(auditStatus) {
      var auditStatusClassMap = {
        0: 'record-status-text--primary',
        1: 'record-status-text--success',
        2: 'record-status-text--danger',
        3: 'record-status-text--info'
      };
      return auditStatusClassMap[auditStatus] || 'record-status-text--info';
    },
    formatAdminName: function formatAdminName(row, column, cellValue) {
      if (!cellValue) {
        return '--';
      }
      var adminUser = this.adminUserOptions.find(function (item) {
        return String(item.id) === String(cellValue);
      });
      return adminUser ? adminUser.realName : cellValue;
    },
    search: function search() {
      var _this = this;
      this.$refs.pageFrom.validate(function (valid) {
        if (!valid) return;
        _this.pageFrom.page = 1;
        _this.getList();
        // this.getSummary();
      });
    },
    handlePhoneInput: function handlePhoneInput(value) {
      this.pageFrom.phone = value.replace(/\D/g, '').slice(0, 11);
    },
    resetSearch: function resetSearch() {
      var _this2 = this;
      Object.assign(this.pageFrom, {
        page: 1,
        customerId: '',
        sendType: '',
        fudouCardId: '',
        customerEmpType: '',
        projectNumber: '',
        phone: '',
        applicationNumber: '',
        auditStatus: '',
        startExeTime: '',
        endExeTime: '',
        startAuditTime: '',
        endAuditTime: '',
        creatorId: '',
        auditorId: '',
        companyId: '',
        appId: '',
        time: []
      });
      this.exeTimeRange = [];
      this.auditTimeRange = [];
      this.$nextTick(function () {
        _this2.$refs.pageFrom.clearValidate('phone');
      });
      this.getList();
    },
    handleExeTimeChange: function handleExeTimeChange(value) {
      this.pageFrom.startExeTime = value && value.length === 2 ? value[0] : '';
      this.pageFrom.endExeTime = value && value.length === 2 ? value[1] : '';
      this.search();
    },
    handleAuditTimeChange: function handleAuditTimeChange(value) {
      this.pageFrom.startAuditTime = value && value.length === 2 ? value[0] : '';
      this.pageFrom.endAuditTime = value && value.length === 2 ? value[1] : '';
      this.search();
    },
    handleCreatorSearch: function () {
      var _handleCreatorSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(keyword) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.creatorLoading = true;
              _context.p = 1;
              _context.n = 2;
              return suplierCouponsApi.getAllUser(keyword || '');
            case 2:
              res = _context.v;
              this.creatorOptions = res || [];
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取提交人列表失败:', _t);
              this.creatorOptions = [];
            case 4:
              _context.p = 4;
              this.creatorLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handleCreatorSearch(_x) {
        return _handleCreatorSearch.apply(this, arguments);
      }
      return handleCreatorSearch;
    }(),
    handleCreatorFocus: function handleCreatorFocus() {
      if (!this.creatorOptions.length) {
        this.handleCreatorSearch('');
      }
    },
    getAdminUserOptions: function () {
      var _getAdminUserOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return suplierCouponsApi.getAllUser('');
            case 1:
              res = _context2.v;
              this.adminUserOptions = res || [];
              this.creatorOptions = this.adminUserOptions;
              this.auditorOptions = this.adminUserOptions;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取管理员列表失败:', _t2);
              this.adminUserOptions = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getAdminUserOptions() {
        return _getAdminUserOptions.apply(this, arguments);
      }
      return getAdminUserOptions;
    }(),
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    // 归属公司
    getCustomers: function () {
      var _getCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _api.activeCustomersApi)();
            case 1:
              res = _context3.v;
              console.log("归属公司", res);
              this.customers = res;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getCustomers() {
        return _getCustomers.apply(this, arguments);
      }
      return getCustomers;
    }(),
    // 获取发卡类型列表（枚举接口）
    getCardTypeList: function () {
      var _getCardTypeList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _requestMapi.default)({
                url: '/mapi/asset/dict/card-type',
                method: 'GET'
              });
            case 1:
              res = _context4.v;
              console.log("发卡类型列表", res);
              this.sendTypeList = res || [];
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              console.error('获取发卡类型列表失败:', _t3);
              this.sendTypeList = [];
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getCardTypeList() {
        return _getCardTypeList.apply(this, arguments);
      }
      return getCardTypeList;
    }(),
    // 获取公司列表（从user-service调用）
    getCompanyList: function () {
      var _getCompanyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _requestMapi.default)({
                url: '/mapi/user/company/options',
                method: 'GET',
                params: {}
              });
            case 1:
              res = _context5.v;
              console.log("公司列表", res);
              this.companyList = res || [];
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              console.error('获取公司列表失败:', _t4);
              this.companyList = [];
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function getCompanyList() {
        return _getCompanyList.apply(this, arguments);
      }
      return getCompanyList;
    }(),
    getFuCardOptions: function getFuCardOptions() {
      var _this3 = this;
      (0, _customerOrderPreApi.customerOrderPreFuCardListApi)({
        keyword: '',
        isCombo: false
      }).then(function (res) {
        var list = Array.isArray(res) ? res : [];
        _this3.fuCardOptions = list.map(function (item) {
          return {
            id: item.id,
            cardName: item.card_name || item.cardName
          };
        }).filter(function (item) {
          return item.id !== undefined && item.id !== null && item.cardName;
        });
      });
    },
    // 获取小程序列表
    getMiniappList: function () {
      var _getMiniappList2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return (0, _projectManageApi.getMiniappList)();
            case 1:
              res = _context6.v;
              console.log("小程序列表", res);
              this.miniappList = res || [];
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              console.error('获取小程序列表失败:', _t5);
              this.miniappList = [];
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function getMiniappList() {
        return _getMiniappList2.apply(this, arguments);
      }
      return getMiniappList;
    }(),
    // 详情
    detail: function detail(row) {
      this.$refs.DetailVueRef.open(row.id);
    },
    // 列表
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var params, res, _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              this.loading = true;
              _context7.p = 1;
              // 处理时间参数
              params = _objectSpread({}, this.pageFrom);
              if (params.time && params.time.length === 2) {
                params.startTime = params.time[0];
                params.endTime = params.time[1];
              }
              delete params.time; // 删除原始的 time 数组

              console.log('正在发送列表请求，参数:', params);
              _context7.n = 2;
              return (0, _api.listApi)(params);
            case 2:
              res = _context7.v;
              console.log('列表接口返回数据:', res);

              // 确保 res 是有效对象
              if (res && _typeof(res) === 'object') {
                // 兼容两种返回格式：新格式直接是分页数据，旧格式从 page 字段中获取
                if (res.list !== undefined || res.total !== undefined) {
                  this.tableData = {
                    list: res.list || [],
                    total: res.total || 0
                  };
                } else if (res.page) {
                  this.tableData = res.page;
                } else {
                  console.error('返回数据格式错误:', res);
                  this.tableData = {
                    list: [],
                    total: 0
                  };
                }
              } else {
                console.error('列表接口返回数据格式错误:', res);
                this.tableData = {
                  list: [],
                  total: 0
                };
              }
              this.loading = false;
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t6 = _context7.v;
              console.error('获取列表数据失败:', _t6);
              this.tableData = {
                list: [],
                total: 0
              };
              this.loading = false;
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this, [[1, 3]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 导出操作记录
    exportRecord: function () {
      var _exportRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var params, res, _t7;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              // 显示导出进度弹窗
              this.exportDialogTitle = '操作记录导出';
              this.exportConditionText = this.generateExportConditionText('操作记录导出');
              this.isExporting = true;
              this.exportProgress = 0;
              this.exportProgressText = '正在创建导出任务...';
              params = _objectSpread({}, this.pageFrom); // 移除分页参数，导出全部数据
              delete params.page;
              delete params.limit;
              // 处理时间参数
              if (params.time && params.time.length === 2) {
                params.startTime = params.time[0];
                params.endTime = params.time[1];
              }
              delete params.time;

              // 调用异步导出接口
              _context8.n = 1;
              return (0, _api.asyncExportRecordApi)(params);
            case 1:
              res = _context8.v;
              console.log('异步导出操作记录>>>>>>>>>>>>>>>>>>>>>>>>', res);
              if (res && res.taskId) {
                // 开始轮询查询任务状态
                this.exportProgressText = '正在导出...';
                this.startPollExportTask(res.taskId, 'CUSTOMER_INTEGRAL_LOG_EXPORT');
              } else {
                this.$message.error('创建导出任务失败');
                this.isExporting = false;
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t7 = _context8.v;
              console.error('导出操作记录失败', _t7);
              this.$message.error('导出失败，请稍后重试');
              this.isExporting = false;
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function exportRecord() {
        return _exportRecord.apply(this, arguments);
      }
      return exportRecord;
    }(),
    // 导出操作明细
    exportRecordDetail: function () {
      var _exportRecordDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var params, res, _t8;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              // 显示导出进度弹窗
              this.exportDialogTitle = '操作明细导出';
              this.exportConditionText = this.generateExportConditionText('操作明细导出');
              this.isExporting = true;
              this.exportProgress = 0;
              this.exportProgressText = '正在创建导出任务...';
              params = _objectSpread({}, this.pageFrom); // 移除分页参数，导出全部数据
              delete params.page;
              delete params.limit;
              // 处理时间参数
              if (params.time && params.time.length === 2) {
                params.startTime = params.time[0];
                params.endTime = params.time[1];
              }
              delete params.time;

              // 调用异步导出明细接口
              _context9.n = 1;
              return (0, _api.asyncExportRecordDetailApi)(params);
            case 1:
              res = _context9.v;
              console.log('异步导出操作明细>>>>>>>>>>>>>>>>>>>>>>>>', res);
              if (res && res.taskId) {
                // 开始轮询查询任务状态
                this.exportProgressText = '正在导出...';
                this.startPollExportTask(res.taskId, 'CUSTOMER_INTEGRAL_LOG_DETAIL_EXPORT');
              } else {
                this.$message.error('创建导出任务失败');
                this.isExporting = false;
              }
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t8 = _context9.v;
              console.error('导出操作明细失败', _t8);
              this.$message.error('导出失败，请稍后重试');
              this.isExporting = false;
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function exportRecordDetail() {
        return _exportRecordDetail.apply(this, arguments);
      }
      return exportRecordDetail;
    }(),
    // 开始轮询导出任务状态
    startPollExportTask: function startPollExportTask(taskId, taskType) {
      var _this4 = this;
      // 清除之前的轮询定时器
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      var pollCount = 0;
      var maxPollCount = 20; // 最多轮询1分钟（20 * 3秒）

      this.pollTimer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var taskRes, downloadUrl, link, _t9;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              pollCount++;
              if (!(pollCount > maxPollCount)) {
                _context0.n = 1;
                break;
              }
              clearInterval(_this4.pollTimer);
              _this4.pollTimer = null;
              _this4.isExporting = false;
              _this4.$message.warning('导出任务处理时间较长，请前往导出任务列表查看');
              return _context0.a(2);
            case 1:
              _context0.p = 1;
              _context0.n = 2;
              return (0, _api.getExportTaskStatusApi)(taskId);
            case 2:
              taskRes = _context0.v;
              console.log('查询导出任务状态返回：', taskRes);
              if (taskRes) {
                _context0.n = 3;
                break;
              }
              clearInterval(_this4.pollTimer);
              _this4.pollTimer = null;
              _this4.isExporting = false;
              _this4.$message.error('任务不存在');
              return _context0.a(2);
            case 3:
              // 更新进度
              _this4.exportProgress = taskRes.progress || 0;
              if (taskRes.status === 'PROCESSING') {
                _this4.exportProgressText = "\u6B63\u5728\u5BFC\u51FA...".concat(_this4.exportProgress, "%");
              } else if (taskRes.status === 'COMPLETED') {
                // 任务完成
                clearInterval(_this4.pollTimer);
                _this4.pollTimer = null;
                _this4.exportProgress = 100;
                _this4.exportProgressText = '导出完成！';

                // 下载文件
                if (taskRes.filePath) {
                  _this4.downloadFileByFilePath(taskRes.filePath, taskRes.fileName);
                } else if (taskRes.downloadUrl) {
                  downloadUrl = taskRes.downloadUrl.startsWith('/') ? taskRes.downloadUrl : "/api/admin/customer/integral-log/file/".concat(taskRes.fileName);
                  link = document.createElement('a');
                  link.href = downloadUrl;
                  link.target = '_blank';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  _this4.$message.success('导出成功');
                } else {
                  _this4.$message.error('导出文件生成失败');
                }

                // 延迟关闭弹窗
                setTimeout(function () {
                  _this4.isExporting = false;
                }, 1500);
              } else if (taskRes.status === 'FAILED') {
                clearInterval(_this4.pollTimer);
                _this4.pollTimer = null;
                _this4.isExporting = false;
                _this4.$message.error("\u5BFC\u51FA\u5931\u8D25: ".concat(taskRes.errorMessage || '未知错误'));
              } else if (taskRes.status === 'PENDING') {
                _this4.exportProgressText = '等待处理...';
              }
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t9 = _context0.v;
              console.error('查询导出任务状态失败', _t9);
              // 不中断轮询，继续尝试
            case 5:
              return _context0.a(2);
          }
        }, _callee0, null, [[1, 4]]);
      })), 2000);
    },
    // 轮询导出任务状态（兼容旧代码）
    pollExportTask: function () {
      var _pollExportTask = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(taskId, exportType) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.startPollExportTask(taskId, exportType === '导出操作记录' ? 'CUSTOMER_INTEGRAL_LOG_EXPORT' : 'CUSTOMER_INTEGRAL_LOG_DETAIL_EXPORT');
            case 1:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function pollExportTask(_x2, _x3) {
        return _pollExportTask.apply(this, arguments);
      }
      return pollExportTask;
    }(),
    // 打开导出任务列表弹窗
    openExportTaskDialog: function openExportTaskDialog() {
      this.exportTaskDialogVisible = true;
      this.getExportTaskList();
    },
    // 获取导出任务列表
    getExportTaskList: function () {
      var _getExportTaskList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var params, res, _t0;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              this.exportTaskLoading = true;
              _context10.p = 1;
              params = {
                page: this.exportTaskPageFrom.page,
                limit: this.exportTaskPageFrom.limit,
                // 只查询积分日志导出相关任务
                taskType: ''
              };
              _context10.n = 2;
              return (0, _api.getExportTaskListApi)(params);
            case 2:
              res = _context10.v;
              console.log('导出任务列表返回：', res);
              if (res && res.list) {
                // 过滤出积分日志导出任务
                this.exportTaskList = res.list.filter(function (item) {
                  return item.taskType === 'CUSTOMER_INTEGRAL_LOG_EXPORT' || item.taskType === 'CUSTOMER_INTEGRAL_LOG_DETAIL_EXPORT';
                });
                this.exportTaskListTotal = res.total || 0;
              } else {
                this.exportTaskList = [];
                this.exportTaskListTotal = 0;
              }
              _context10.n = 4;
              break;
            case 3:
              _context10.p = 3;
              _t0 = _context10.v;
              console.error('获取导出任务列表失败', _t0);
              this.exportTaskList = [];
              this.exportTaskListTotal = 0;
            case 4:
              _context10.p = 4;
              this.exportTaskLoading = false;
              return _context10.f(4);
            case 5:
              return _context10.a(2);
          }
        }, _callee10, this, [[1, 3, 4, 5]]);
      }));
      function getExportTaskList() {
        return _getExportTaskList.apply(this, arguments);
      }
      return getExportTaskList;
    }(),
    // 导出任务列表分页
    exportTaskHandleSizeChange: function exportTaskHandleSizeChange(val) {
      this.exportTaskPageFrom.limit = val;
      this.getExportTaskList();
    },
    exportTaskHandlePageChange: function exportTaskHandlePageChange(val) {
      this.exportTaskPageFrom.page = val;
      this.getExportTaskList();
    },
    // 下载导出任务文件
    downloadExportTaskFile: function downloadExportTaskFile(row) {
      if (row.filePath) {
        this.downloadFileByFilePath(row.filePath, row.fileName);
      } else if (row.downloadUrl) {
        var downloadUrl = row.downloadUrl.startsWith('/') ? row.downloadUrl : "/api/admin/customer/integral-log/file/".concat(row.fileName);
        var link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success('下载成功');
      } else {
        this.$message.error('文件不存在');
      }
    },
    // 格式化任务类型名称
    formatTaskTypeName: function formatTaskTypeName(taskType) {
      var typeMap = {
        'CUSTOMER_INTEGRAL_LOG_EXPORT': '积分日志导出',
        'CUSTOMER_INTEGRAL_LOG_DETAIL_EXPORT': '积分日志明细导出'
      };
      return typeMap[taskType] || taskType || '未知';
    },
    // 格式化状态名称
    formatStatusName: function formatStatusName(status) {
      var statusMap = {
        'PENDING': '等待处理',
        'PROCESSING': '处理中',
        'COMPLETED': '已完成',
        'FAILED': '失败'
      };
      return statusMap[status] || status || '未知';
    },
    // 使用filePath下载文件（与订单导出保持一致）
    downloadFileByFilePath: function () {
      var _downloadFileByFilePath = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(filePath, fileName) {
        var downloadUrl, httpsIndex, link;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              try {
                console.log('开始下载文件，filePath:', filePath);
                console.log('文件名:', fileName);

                // 从filePath中提取HTTPS URL部分
                downloadUrl = filePath; // 如果filePath包含https，则从https开始截取到最后
                httpsIndex = filePath.indexOf('https://');
                if (httpsIndex !== -1) {
                  downloadUrl = filePath.substring(httpsIndex);
                }
                console.log('原始filePath:', filePath);
                console.log('处理后的downloadUrl:', downloadUrl);

                // 创建隐藏的下载链接
                link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName || 'download.xlsx';
                link.target = '_blank';
                link.style.display = 'none';

                // 添加到DOM并触发点击
                document.body.appendChild(link);
                link.click();

                // 清理DOM
                document.body.removeChild(link);
                this.$message.success((this.exportType || '导出') + '成功');
              } catch (error) {
                console.error('下载文件失败：', error);
                this.$message.error('下载文件失败：' + (error.message || '未知错误'));
              }
            case 1:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function downloadFileByFilePath(_x4, _x5) {
        return _downloadFileByFilePath.apply(this, arguments);
      }
      return downloadFileByFilePath;
    }()
  },
  created: function created() {
    this.isMinAdmin = suplierCouponsApi.getAdminType();
    this.miniProgramCustomer = suplierCouponsApi.getHomeType();
    this.miniProgramCustomerId = suplierCouponsApi.getCustomerId();
    this.getList();
    // this.getSummary();
    this.getCustomers();
    this.getCompanyList();
    this.getFuCardOptions();
    this.getMiniappList();
    this.getAdminUserOptions();
  }
};